import AOS from 'aos';

/*
options:
 */

/*
events :
    refresh-aos
 */

export default class WbxAos {
    constructor() {
        this.init();
    }

    init() {
        AOS.init({
            startEvent: 'load',
        });
        window.addEventListener('refresh-aos', () => {
            AOS.refresh();
        });
    }
}
